import { render, staticRenderFns } from "./ModalDestruccion.vue?vue&type=template&id=8af372b4"
import script from "./ModalDestruccion.vue?vue&type=script&lang=js"
export * from "./ModalDestruccion.vue?vue&type=script&lang=js"
import style0 from "./ModalDestruccion.vue?vue&type=style&index=0&id=8af372b4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8af372b4')) {
      api.createRecord('8af372b4', component.options)
    } else {
      api.reload('8af372b4', component.options)
    }
    module.hot.accept("./ModalDestruccion.vue?vue&type=template&id=8af372b4", function () {
      api.rerender('8af372b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalDestruccion.vue"
export default component.exports